import { Skeleton } from '@/_components/ui/skeleton'

interface SkeletonPageHeaderProps {
  titleWidth?: string
  subtitle?: { width: string }
  tabs: { width: string }[]
}

export const SkeletonPageHeader = ({
  titleWidth = 'w-48',
  subtitle,
  tabs,
  showBack = false,
}: SkeletonPageHeaderProps & { showBack?: boolean }) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-2">
        {showBack && <Skeleton className="h-4 w-12" />}
        <Skeleton className={`h-7 ${titleWidth}`} />
      </div>

      {subtitle && <Skeleton className={`h-5 ${subtitle.width}`} />}

      {tabs.length > 0 && (
        <div className="flex gap-6 border-b border-brand-grayscale-4 pb-2">
          {tabs.map((tab, i) => (
            <Skeleton key={i} className={`h-4 ${tab.width}`} />
          ))}
        </div>
      )}
    </div>
  )
}
